"use client"
import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import { sendNoResultFound } from "@/lib/gtm"
import colors from "@/lib/theme/colors"
import styled from "@emotion/styled"
import { Box, Button, Typography } from "@mui/material"
import Image from "next/image"
import { useRouter, useSearchParams } from "next/navigation"
import { useEffect } from "react"

const StyledWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 18px;
  color: ${colors.directBlack};
  gap: 16px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 24px;
    gap: 8px;
    margin-bottom: 48px;
  }
`

const StyledMainText = styled(Typography)`
  font-family: Ploni DL 1.1 AAA;
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0em;
  text-align: center;
  vertical-align: middle;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 32px;
  }
`

const StyledSecondaryText = styled(Typography)`
  font-family: Ploni DL 1.1 AAA;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0em;
  text-align: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

const StyledButton = styled(Button)`
  background-color: ${colors.directAzure};
  margin-top: 16px;
`

const NotFoundCars = (): React.ReactElement => {
  const searchParams = useSearchParams()
  const params = new URLSearchParams(searchParams.toString())
  const router = useRouter()
  useEffect(() => {
    sendNoResultFound()
  }, [])

  return (
    <StyledWrapper>
      <Mobile>
        <Image src="/assets/search-car-icon.svg" alt="לא נמצאו רכבים" width={64} height={64} />
      </Mobile>
      <Desktop>
        <Image src="/assets/search-car-icon.svg" alt="לא נמצאו רכבים" width={96} height={96} />
      </Desktop>
      <Box display={"flex"} flexDirection="column" alignItems="center">
        <StyledMainText>לא מצאנו את הרכב שחיפשת</StyledMainText>
        <StyledSecondaryText>נשמח לעזור במציאת הרכב הבא שלך</StyledSecondaryText>
      </Box>
      <StyledButton
        variant="contained"
        onClick={() => router.push(`/contact-us?${params.toString()}`)}
      >
        להשארת פרטים
      </StyledButton>
    </StyledWrapper>
  )
}

export default NotFoundCars
